import { render, staticRenderFns } from "./mold.vue?vue&type=template&id=27efe783&scoped=true&"
import script from "./mold.vue?vue&type=script&lang=js&"
export * from "./mold.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27efe783",
  null
  
)

export default component.exports